import { Component } from 'react';
import classNames from 'classnames';
import { UnmountClosed } from 'react-collapse';

import { OpenIcon } from './OpenIcon';
import { CloseIcon } from './CloseIcon';

import styles from './CollapsibleSection.module.css';

class CollapsibleSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.isInitiallyOpen
        };
    }

    render() {
        const {
            className,
            title,
            isCollapsible = true,
            children,
            trackEvent = undefined
        } = this.props;
        const { isOpen } = this.state;

        return (
            <div
                data-testid={this.props['data-testid'] || 'collapsible-section'}
                className={classNames(styles.CollapsibleSection, className)}
                aria-expanded={isOpen}
            >
                {title ? (
                    <button
                        className={styles.header}
                        onClick={() => {
                            if (trackEvent) {
                                trackEvent();
                            }
                            this.setState({ isOpen: !isOpen });
                        }}
                    >
                        <h2 className={styles.title}>{title}</h2>

                        {isCollapsible ? (
                            <CollapseIcon isOpen={isOpen} />
                        ) : null}
                    </button>
                ) : null}

                {isCollapsible ? (
                    <UnmountClosed
                        theme={{ collapse: styles.collapse }}
                        isOpened={isOpen}
                    >
                        {children}
                    </UnmountClosed>
                ) : (
                    children
                )}
            </div>
        );
    }
}

function CollapseIcon({ isOpen }) {
    return isOpen ? (
        <CloseIcon className={styles.collapseIcon} />
    ) : (
        <OpenIcon className={styles.collapseIcon} />
    );
}

// eslint-disable-next-line import/no-default-export
export default CollapsibleSection;
